import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'summaryText'
})
export class SummaryTextPipe implements PipeTransform {

  transform(value: string): string {
    if(value.length < 25){
      return value;
    } else {
      let first25Characters = value.substring(0, 26);
      return first25Characters + "...";
    }
  }

}
